'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (GeoLocationReasons) {
    GeoLocationReasons["LOGIN"] = "Login";
    GeoLocationReasons["SIGNUP"] = "Signup";
    GeoLocationReasons["VERIFY_EMAIL"] = "VerifyEmail";
    GeoLocationReasons["PERIODIC"] = "Periodic";
})(exports.GeoLocationReasons || (exports.GeoLocationReasons = {}));
(function (GeoLocationProvider) {
    GeoLocationProvider["GeoLocs"] = "GeoLocs";
    GeoLocationProvider["GeoComply"] = "GeoComply";
})(exports.GeoLocationProvider || (exports.GeoLocationProvider = {}));
